/** Teklif CTA'larinin tumu ayni Hub formuna gider; e-posta istemcisine bagimli kalmaz. */
export function quoteRequestPath(input: {
  solution?: string;
  catalog?: string;
  source?: string;
}): string {
  const params = new URLSearchParams();
  if (input.solution?.trim()) params.set('cozum', input.solution.trim());
  if (input.catalog?.trim()) params.set('katalog', input.catalog.trim());
  if (input.source?.trim()) params.set('kaynak', input.source.trim());
  const query = params.toString();
  return query ? `/teklif-al?${query}` : '/teklif-al';
}
